import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { compareTwoStrings } from "string-similarity";
import VueSelect from "vue-select";
import Deselect from "@/components/utils/ListDeselect.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListSelect',
  props: {
    noFuzzy: { type: Boolean },
    filter: { type: Function }
  },
  setup(__props: any) {

const props = __props;

function fuzzySearch(options: string[], search: string) {
  const scores: Record<string, number> = {};
  options.forEach((opt) => {
    scores[opt] = compareTwoStrings(
      opt.toLocaleLowerCase(),
      search.toLocaleLowerCase()
    );

    // Fuzzy matching doesn't work well for single-char input (score=0) so
    // add a small term to promote results that contain direct match.
    if (opt.toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1) {
      scores[opt] += 0.2;
    }
  });

  return options.sort((a, b) => scores[b] - scores[a]);
}

const filterFn = computed(
  () => props.filter ?? (props.noFuzzy ? undefined : fuzzySearch)
);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createBlock(_unref(VueSelect), _mergeProps(_ctx.$props, {
    components: { Deselect: Deselect },
    filter: filterFn.value
  }), {
    "open-indicator": _withCtx(() => [
      _createVNode(_component_Icon, {
        icon: "fe:drop-down",
        class: "vs-open-icon"
      })
    ]),
    _: 1
  }, 16, ["components", "filter"]))
}
}

})